document.addEventListener('DOMContentLoaded', () => {

    // Sticky Navbar
    const navbar = document.getElementById('navbar');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) navbar.classList.add('scrolled');
        else navbar.classList.remove('scrolled');
    });

    // Intersection Observer for Reveal Animations & Count up
    const observerOptions = { threshold: 0.1, rootMargin: "0px 0px -50px 0px" };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
                
                // Trigger count up if it has the class
                if (entry.target.classList.contains('comp-card') || entry.target.classList.contains('stat-item') || entry.target.classList.contains('card-white')) {
                    const counters = entry.target.querySelectorAll('.count-up, .count-up-dollar');
                    counters.forEach(counter => {
                        const target = parseFloat(counter.getAttribute('data-target'));
                        const isDollar = counter.classList.contains('count-up-dollar');
                        const duration = 2000; // ms
                        const increment = target / (duration / 16); // 60fps
                        let current = 0;
                        
                        const updateCounter = () => {
                            current += increment;
                            if (current < target) {
                                // Format logic for decimals vs integers
                                let val = target % 1 === 0 ? Math.ceil(current) : current.toFixed(1);
                                counter.innerText = isDollar ? '$' + Number(val).toLocaleString() : val;
                                requestAnimationFrame(updateCounter);
                            } else {
                                counter.innerText = isDollar ? '$' + target.toLocaleString() : target;
                            }
                        };
                        updateCounter();
                        counter.classList.remove('count-up'); // Ensure we only count once
                        counter.classList.remove('count-up-dollar');
                    });
                }
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    document.querySelectorAll('.reveal-up, .stat-item, .card-white, .comp-card').forEach(el => {
        observer.observe(el);
    });

    // Magnetic Button Effect
    const magneticElements = document.querySelectorAll('.magnetic');
    magneticElements.forEach(element => {
        element.addEventListener('mousemove', (e) => {
            const rect = element.getBoundingClientRect();
            const x = e.clientX - rect.left - rect.width / 2;
            const y = e.clientY - rect.top - rect.height / 2;
            
            // Limit the distance the element can move
            element.style.transform = `translate(${x * 0.2}px, ${y * 0.2}px)`;
        });

        element.addEventListener('mouseleave', () => {
            element.style.transform = `translate(0px, 0px)`;
        });
    });
});

// Conversational Funnel Logic (Intake Form)
const funnelData = {
    totalSteps: 6, // 0 to 5, then success (6)
    results: {},
    isSubmitting: false
};

function setFunnelSubmitState(isSubmitting) {
    funnelData.isSubmitting = isSubmitting;

    const submitButton = document.querySelector('.lp-step[data-step="5"] .btn-funnel-submit');
    if (!submitButton) return;

    submitButton.disabled = isSubmitting;

    const submitText = submitButton.querySelector('.btn-submit-text');
    if (submitText) {
        submitText.textContent = isSubmitting ? 'Sending...' : 'Get My Free Website';
    }
}

async function submitFunnelLead() {
    const payload = {
        ...funnelData.results,
        submittedAt: new Date().toISOString()
    };

    const response = await fetch('/api/funnel', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(data.error || 'Lead submission failed.');
    }

    return data;
}

function updateProgressBar(step) {
    const progressFill = document.getElementById('funnel-progress-fill');
    if (!progressFill) return;
    
    // Success step (6) is 100%
    // Otherwise calculate based on 0-5
    const percentage = Math.min((step / 6) * 100, 100);
    progressFill.style.width = percentage + '%';
}

function resetFunnel() {
    funnelData.results = {};
    funnelData.isSubmitting = false;
    window.funnel.currentStep = 0;

    // Reset all steps visibility
    document.querySelectorAll('.lp-step').forEach(s => s.classList.remove('active'));
    const firstStep = document.querySelector('.lp-step[data-step="0"]');
    if (firstStep) firstStep.classList.add('active');

    // Reset progress bar
    updateProgressBar(0);

    // Show progress bar if it was hidden
    const progressBar = document.getElementById('funnel-progress-bar');
    if (progressBar) progressBar.style.display = 'block';

    // Clear and reset inputs
    const inputs = document.querySelectorAll('.funnel-input');
    inputs.forEach(input => {
        input.value = '';
        input.style.borderColor = '';
    });

    setFunnelSubmitState(false);

    // Reset inspiration fields (remove extras)
    const inspContainer = document.getElementById('inspiration-inputs');
    if (inspContainer) {
        const wrappers = inspContainer.querySelectorAll('.funnel-input-wrap');
        for (let i = 1; i < wrappers.length; i++) {
            wrappers[i].remove();
        }
    }
}

window.funnel = {
    currentStep: 0,
    open: () => {
        resetFunnel();
        document.getElementById('funnel-modal').classList.add('active');
        document.body.style.overflow = 'hidden';
    },
    close: () => {
        document.getElementById('funnel-modal').classList.remove('active');
        document.body.style.overflow = 'unset';
    },
    addInspirationField: () => {
        const container = document.getElementById('inspiration-inputs');
        if (!container) return;
        
        const wrap = document.createElement('div');
        wrap.className = 'funnel-input-wrap animate-slide-up';
        wrap.style.marginTop = '0.75rem';
        wrap.innerHTML = `
            <svg class="input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
            <input type="url" class="funnel-input" placeholder="https://another-site.com" />
        `;
        container.appendChild(wrap);
        wrap.querySelector('input').focus();
    },
    next: async (step, value) => {
        // Collect current step data if not already passed
        if (step === 0) {
            funnelData.results.hasWebsite = value;
        } else if (step === 1) {
            const url = document.getElementById('funnel-url').value.trim();
            if (url) funnelData.results.currentUrl = url;
            // Website URL is optional technically, but if they said "Yes" we prefer it
        } else if (step === 2) {
            const inputs = document.querySelectorAll('#inspiration-inputs .funnel-input');
            const inspList = Array.from(inputs).map(i => i.value.trim()).filter(v => v !== '');
            if (inspList.length > 0) funnelData.results.inspiration = inspList;
        } else if (step === 3) {
            const name = document.getElementById('funnel-name').value.trim();
            if (name.length < 2) {
                const input = document.getElementById('funnel-name');
                input.focus();
                input.style.borderColor = '#ef4444';
                setTimeout(() => { input.style.borderColor = ''; }, 1500);
                return;
            }
            funnelData.results.name = name;
        } else if (step === 4) {
            const phone = document.getElementById('funnel-phone').value.trim();
            if (phone.length < 7) {
                const input = document.getElementById('funnel-phone');
                input.focus();
                input.style.borderColor = '#ef4444';
                setTimeout(() => { input.style.borderColor = ''; }, 1500);
                return;
            }
            funnelData.results.phone = phone;
        } else if (step === 5) {
            const email = document.getElementById('funnel-email').value.trim();
            if (!email.includes('@') || !email.includes('.')) {
                const input = document.getElementById('funnel-email');
                input.focus();
                input.style.borderColor = '#ef4444';
                setTimeout(() => { input.style.borderColor = ''; }, 1500);
                return;
            }
            funnelData.results.email = email;

            if (funnelData.isSubmitting) return;

            try {
                setFunnelSubmitState(true);
                await submitFunnelLead();
                console.log('Intake complete:', funnelData.results);
            } catch (error) {
                console.error('Lead submission failed:', error);
                alert("We couldn't send your request right now. Please try again in a minute.");
                setFunnelSubmitState(false);
                return;
            }
        }

        let nextStep = step + 1;
        
        // CONDITIONAL ROUTING: Skip Step 1 (URL) if they don't have a website
        if (step === 0 && !funnelData.results.hasWebsite.includes('Yes')) {
            nextStep = 2;
        }

        // Update step visibility
        const currentEl = document.querySelector(`.lp-step[data-step="${step}"]`);
        const nextEl = document.querySelector(`.lp-step[data-step="${nextStep}"]`);
        
        if (currentEl) currentEl.classList.remove('active');
        if (nextEl) nextEl.classList.add('active');

        // Update progress
        updateProgressBar(nextStep);

        // Handle success step (6)
        if (nextStep === 6) {
            const progressBar = document.getElementById('funnel-progress-bar');
            if (progressBar) progressBar.style.display = 'none';

            const nameEcho = document.getElementById('funnel-name-echo');
            if (nameEcho && funnelData.results.name) {
                nameEcho.textContent = funnelData.results.name.split(' ')[0];
            }

            setFunnelSubmitState(false);
        }

        // Auto-focus first input on the next step
        if (nextEl) {
            const firstInput = nextEl.querySelector('input');
            if (firstInput) setTimeout(() => firstInput.focus(), 400);
        }
        
        window.funnel.currentStep = nextStep;
    }
};

// Enter key support for all input steps
document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const modal = document.getElementById('funnel-modal');
    if (!modal || !modal.classList.contains('active')) return;

    const activeStep = document.querySelector('.lp-step.active');
    if (!activeStep) return;
    
    const stepNum = parseInt(activeStep.getAttribute('data-step'));
    
    // Steps that have inputs (1, 2, 3, 4, 5)
    if (stepNum >= 1 && stepNum <= 5) {
        e.preventDefault();
        window.funnel.next(stepNum);
    }
});

